<div class="table" [ngClass]="{ 'direct-message': isDirect }">
  <div class="table-cell imagebox">
    <!--<img *ngIf="0 < imageFile.url.length" class="image" [src]="imageFile.url | safe: 'resourceUrl'" />-->
  </div>
  <div class="table-cell">
    <!--<div>
      <select style="width: 12em;" [(ngModel)]="sendFrom">
        <option *ngIf="!onlyCharacters" value="{{myPeer?.identifier}}">{{myPeer?.name}}（あなた）</option>
        <option *ngFor="let gameCharacter of gameCharacters" value="{{gameCharacter.identifier}}">
          {{gameCharacter.name}}
        </option>
      </select> ＞
      <select style="width: 10em;" [(ngModel)]="sendTo">
        <option value="">全員</option>
        <option *ngFor="let peer of otherPeers" value="{{peer.identifier}}">
          {{peer.name}}
          <ng-container *ngIf="peer === myPeer">（あなた）</ng-container>
        </option>
      </select>
      <ng-container *ngIf="0 < diceBotInfos.length">
        <select style="width: 12em;" (change)="loadDiceBot($event.target.value)" [(ngModel)]="gameType"
                [ngModelOptions]="{standalone: true}">
          <option *ngFor="let diceBotInfo of diceBotInfos" value="{{diceBotInfo.id}}">{{diceBotInfo.name === "DiceBot" ? "ダイスボット指定なし" : diceBotInfo.name}}</option>
        </select>
      </ng-container>
      <ng-container *ngIf="diceBotInfos.length < 1">
        <select style="width: 12em;" disabled>
          <option value="">ダイスボット読込中...</option>
        </select>
      </ng-container>
      <button (click)="showDicebotHelp()" [disabled]="diceBotInfos.length < 1">?</button>-->
      <div *ngIf="this.chatTabidentifier != 'MainTab'">
        <form>
          <textarea class="chat-input" placeholder="Enterで送信  Shift+Enterで改行" [(ngModel)]="text"
                    [ngModelOptions]="{standalone: true}" (input)="onInput()" (keydown.enter)="sendChat($event)"
                    #textArea></textarea>
          <button type="submit" (click)="sendChat(null)">送信</button>
        </form>
        <button type="submit" (click)="sendChat(null,'0現1選')">0現1選</button>
        <button type="submit" (click)="sendChat(null,'0現2選')">0現2選</button>
        <button type="submit" (click)="sendChat(null,'1現1選')">1現1選</button>
        <button type="submit" (click)="sendChat(null,'1現2選')">1現2選</button>
        <button type="submit" (click)="sendChat(null,'2現1選')">2現1選</button>
        <button type="submit" (click)="sendChat(null,'2現2選')">2現2選</button>
      </div>
      <div class="writing-info">
        <ng-container *ngIf="0 < writingPeerNames.length">
          <span *ngFor="let peerName of writingPeerNames; index as i" style="font-weight: bold;">
            {{peerName}}<span *ngIf="writingPeerNames.length !== (i + 1)">, </span>
          </span>
          <span> が入力中...</span>
        </ng-container>
      </div>
    </div>
  </div>
